var _defs, _text, _text2, _text3, _text4, _text5, _path, _text6, _text7, _path2, _text8, _text9, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _text0, _text1, _path6, _text10, _text11, _text12, _path7, _rect, _rect2, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1470.58 66.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4,.cls-5,.cls-6{isolation:isolate;}.cls-1,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{font-size:29.8px;fill:#231f20;}.cls-1,.cls-3,.cls-4,.cls-5{font-family:KozGoPr6N-Regular-83pv-RKSJ-H, Kozuka Gothic Pr6N;}.cls-2,.cls-4{letter-spacing:-0.02em;}.cls-3{letter-spacing:-0.05em;}.cls-5{letter-spacing:-0.01em;}.cls-6,.cls-8{font-family:Helvetica;}.cls-7{fill:#d03c2d;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(47.63 47.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, "\u30B9"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.2,
    y: 0
  }, "\u30D1"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(106.63 47.69)"
  }, "\u30A4")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(133.74 47.69)"
  }, "\u30B7")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(163.24 47.69)"
  }, "\u30FC")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(193.04 47.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, " Spicy"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.65,24.67s1.74,5.43,0,9.69c0,0-7,5.24-6.6,13.19s-.77,20.94-10.66,30.83c0,0-4.27,3.88,1.16,3.5,5-.36,21.29-7.41,25.13-31.4a19.47,19.47,0,0,0-2-12.49,13.33,13.33,0,0,0-.8-1.3c-1.94-2.71-2.13-12-2.13-12S31,21.76,28.65,24.67Z",
    transform: "translate(-9.79 -21.66)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(407 47.69)"
  }, "\u725B\u8089")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(466.59 47.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, " Beef"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M331.38,36h0l-7.2,7s-1.22,1,0,1.66l1.22.67s-.89,2,3.21.89,6.87-1.33,8.76.33,11.18,11.7,11.18,11.7h0s1.89,5.65-2.21,16h4.32A111.87,111.87,0,0,0,351.78,63H353s1.3,7.38,0,9.31c-.17.24-1.11.44-1.11.44v1.44h3.66V58.35h0s6.87-.67,9.53,1.33,9.75.55,12.52-1c0,0,3.11-1.11,3.55.22s1.11,3.66,7.43,3.55h0S390.13,70,385.7,74.2h5L392,65.11l1.33.33h0v7.65h-1.56v1.55h3.88V58.35h0A8.08,8.08,0,0,1,395,52.7a10.62,10.62,0,0,1,1.88-4.44s.78-1.55.67,3,0,11.86,0,11.86h0a3,3,0,0,0,2.47-.87,2.2,2.2,0,0,0-.42-3.07h-.07l-1.11-15.3h0s1.89-6.43-4.65-7.87H340.14V35.2a1.3,1.3,0,0,0-1.3-1.3h0a1.29,1.29,0,0,0-1.17.72l-.26.16a1.54,1.54,0,0,1-2.09-.45L335,33.9h0S333.6,32.3,331.38,36Z",
    transform: "translate(-9.79 -21.66)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(967.47 47.69)"
  }, "\u5C0F\u9AA8")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1027.07 47.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, " Bone"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883.73,64.83s1.73,6.62-5.89,12.66a37.66,37.66,0,0,1-19.56-13.38l-.12-1.44,3.45-.14-.6-1.76-4.31-4.32s13.37-10.89,24.88-9.88a21.14,21.14,0,0,1,3,11.79Z",
    transform: "translate(-9.79 -21.66)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M940.9,57.71c1.48-2.11,5.3-6.12,13.87-8,0,0-4.74,6-4.31,11.42s7.19,9.72,7.19,9.72-8.49,1.6-16.33-7.08a4.36,4.36,0,0,1-1.16-2.72v-.73A4.19,4.19,0,0,1,940.9,57.71Z",
    transform: "translate(-9.79 -21.66)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883.73,65.37c1.44,0,57.52-4.11,57.52-4.11V59.91l-57.52-1.29Z",
    transform: "translate(-9.79 -21.66)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 878.4,
    cy: 39.8,
    rx: 1.44,
    ry: 19.99
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 885.3,
    cy: 39.45,
    rx: 1.29,
    ry: 19.63
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 892.28,
    cy: 39.09,
    rx: 1.51,
    ry: 18.41
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 900.26,
    cy: 39.16,
    rx: 1.58,
    ry: 17.18
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 906.59,
    cy: 39.59,
    rx: 1.01,
    ry: 15.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 913.42,
    cy: 40.02,
    rx: 0.79,
    ry: 14.31
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 918.81,
    cy: 39.59,
    rx: 0.86,
    ry: 13.88
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 925.57,
    cy: 39.59,
    rx: 0.86,
    ry: 11.58
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(677.9 47.69)"
  }, "\u8C5A\u8089")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(737.49 47.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, " Pork"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M597.56,47.77A19.08,19.08,0,0,1,593,53.14a2.81,2.81,0,0,0-1.07,2.23v3.26a1.15,1.15,0,0,0,1,1.15c3.07.49,12.43,2.32,14,6.6a7,7,0,0,1-2,6.27V74.2h6.47a12.26,12.26,0,0,0,2.43-5.8h2.42a7,7,0,0,1,1.58,3.44h4.31V68.2h7.69s6.07-.4,9-1.62,1.82,3.58,1.82,3.58l.2.67h-1.41L639.34,73l6.14.07L647,69.75a3.48,3.48,0,0,1,4.26,1.09c2.63,2.29,1.82,4.59,1.82,4.59h5.46s1-4.45-2.16-6.88l2.9-10a7.16,7.16,0,0,0,.75-4.45l.34-.12a7.1,7.1,0,0,0,4.58-6.68V44h-1.19l.07,2.49s-.27,1.29-2,.07-3.31-10.25-25.7-12.41A70.35,70.35,0,0,0,604.87,40s-3.71,1.15-5.67.13-3.44-2-3.84-1.07-.61,1.48-.14,1.82A8.58,8.58,0,0,1,597.79,43C598.91,44.33,598.39,45.57,597.56,47.77Z",
    transform: "translate(-9.79 -21.66)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(1235.75 47.69)"
  }, "\u63A8\u85A6")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1295.34 47.69)"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1301.66 47.69)"
  }, "Recommend")), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1184,85.61l-1.62-2.31L1199,71.72a1.26,1.26,0,0,0-.18-1.17L1186,51.14a3.72,3.72,0,0,0-1.19-.16l-18.12,12.43-1.59-2.33,18.77-12.9h.38c.71,0,3.09-.1,4.09,1.4L1201.14,69a3.93,3.93,0,0,1-.06,4.62l-.13.17Z",
    transform: "translate(-9.79 -21.66)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1185.61,
    y: 57.92,
    width: 2.82,
    height: 21.48,
    transform: "translate(152.95 650.82) rotate(-33.83)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1177.02,
    y: 54,
    width: 2.82,
    height: 3.63,
    transform: "translate(115.87 566.6) rotate(-29.54)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1188.35,51.07l-2.43-1.43c.06-.11,6.6-11.47,2.94-18.5-1.41-2.69-1.82-5-1.21-6.73a3.83,3.83,0,0,1,1.75-2.18c1.29-.81,4.37-1.29,7.43,2.36,2.3,2.75,3.78,7.26,4.5,9.84l9.14-6.15A7.45,7.45,0,0,1,1213.8,27a5,5,0,0,1,5.43,2.89c1.93,4.06-1.08,6.24-3.5,8-.47.34-1,.69-1.45,1.07l-1.77-2.21c.52-.41,1-.78,1.54-1.15,2.81-2,3.43-2.74,2.58-4.52a2.19,2.19,0,0,0-2.58-1.29,4.77,4.77,0,0,0-2.07.82l-12.48,8.45-.43-2c0-.07-1.55-7.17-4.42-10.61-2.13-2.61-3.62-1.85-3.78-1.76l-.16.12h0c-.49.29-1.07,1.78.65,5.09C1195.74,38.26,1188.65,50.56,1188.35,51.07Z",
    transform: "translate(-9.79 -21.66)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1217.16,45.75l-1.55-2.36,2.58-1.67a3.07,3.07,0,0,0,1.34-3.16,2.92,2.92,0,0,0-2.28-2.4l-.22,0,.56-2.77.2,0a5.74,5.74,0,0,1,4.46,4.65,5.81,5.81,0,0,1-2.58,6Z",
    transform: "translate(-9.79 -21.66)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1220.41,52.61l-1.55-2.36,2.58-1.67a3,3,0,0,0,1.31-3.18,2.92,2.92,0,0,0-2.29-2.4h-.15l.59-2.76.2,0a5.77,5.77,0,0,1,4.46,4.65,5.84,5.84,0,0,1-2.58,6Z",
    transform: "translate(-9.79 -21.66)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1201,70.76l-1.94-2,1.76-1.71a5,5,0,0,1,3.52-1.43h2.85a4.14,4.14,0,0,0,2.22-.65l15.32-9.67a3.07,3.07,0,0,0,1.29-3.14,2.94,2.94,0,0,0-2.29-2.4l-.16,0,.56-2.77.21,0a5.74,5.74,0,0,1,4.45,4.65,5.84,5.84,0,0,1-2.58,6l-15.32,9.68a7,7,0,0,1-3.73,1.07h-2.85a2.25,2.25,0,0,0-1.55.65Z",
    transform: "translate(-9.79 -21.66)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1194.23,87.85a29.9,29.9,0,0,1-5-59.43l.46,2.79A27.07,27.07,0,0,0,1194.23,85a27.38,27.38,0,0,0,26-18.47l2.68.91A30.22,30.22,0,0,1,1194.23,87.85Z",
    transform: "translate(-9.79 -21.66)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1223.89,63.93l-2.76-.57a26.65,26.65,0,0,0,.55-5.42h2.83A29.42,29.42,0,0,1,1223.89,63.93Z",
    transform: "translate(-9.79 -21.66)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1206.33,33.61a27.34,27.34,0,0,0-8.32-2.52l.37-2.79a30.1,30.1,0,0,1,9.18,2.77Z",
    transform: "translate(-9.79 -21.66)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTag);
export default __webpack_public_path__ + "static/media/footer-tag.b1ad5f9702d5ac775b9e758442c0c4c0.svg";
export { ForwardRef as ReactComponent };